import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-skeleton-bars',
  templateUrl: './skeleton-bars.component.html',
  styleUrls: ['./skeleton-bars.component.scss'],
})
export class SkeletonBarsComponent implements OnInit {
  @Input() direction: 'vertical' | 'horizontal' = 'vertical';
  @Input() barCount = 8;

  isVertical: boolean;

  barHeights: string[];
  barWidth: string;

  ngOnInit() {
    this.isVertical = this.direction === 'vertical';

    const barHeights = [];

    for (let i = 0; i < this.barCount; i++) {
      barHeights.push(`${this.randomBetween(10, 100)}%`);
    }

    this.barWidth = `${100 / (this.barCount * 1.4)}%`;
    this.barHeights = barHeights;
  }

  private randomBetween(min: number, max: number) {
    return min + (max - min) * Math.random();
  }
}
